import { useEffect } from 'react';
import { useHistory } from "react-router-dom";

const useNavigate = ({
    pageName = ''
}) => {
    const history = useHistory();
    const SESSION_STORAGE_ITEM_NAME = 'navigate-trakref-' + pageName;

    const push = (url, from = null, stateObj = null) => {
        let defaultFrom = null;
        let state = null;
        let replace = false;
    
        // To handle navigate.push for old structure
        if (from !== null && typeof from === 'object') {
            defaultFrom = from.from || window.location.pathname;
            state = from.state || null;
            replace = from.replace || false;
        } else {
            defaultFrom = typeof from === 'string' ? from : stateObj?.from || window.location.pathname;
            state = stateObj || null;
        }
        if (replace) {
            history.replace(url,{
                from: defaultFrom,
                ...state
            });
        } else {
            history.push(url, {
                from: defaultFrom,
                ...state
            });
        }
    };

    const goBack = (defaultUrl, from = null, state = null) => {
        const fromSS = sessionStorage.getItem(SESSION_STORAGE_ITEM_NAME);
        if (!fromSS && (!history || history.length <= 2)) {
            return history.push(defaultUrl);
        }
        
        sessionStorage.removeItem(SESSION_STORAGE_ITEM_NAME);
        if (window.location.href.includes("#"))
            return history.replace((fromSS || from || defaultUrl));

        history.goBack();
    };

    useEffect(() => {
        const stateFrom = (history.location.state && 'from' in history.location.state && history.location.state.from) && history.location.state.from;
        if (pageName && stateFrom) {
            sessionStorage.setItem(SESSION_STORAGE_ITEM_NAME, stateFrom);
        }
    }, []);

    return {
        push,
        goBack,
        pageName
    }
}

export default useNavigate;